<template>
  <div
    class="version-wrapper flex-row-center"
    v-if="ModuleOpenStateControl.model.opened"
  >
    <Bubble
      v-if="!canSelected && createRenderType == 'pc'"
      placement="bottom"
      popper-class="default-model-popover"
    >
      <template v-slot:content>
        <div class="default-model-tip">
          <div class="name">{{ default_model?.display_name }}</div>
          <div class="desc">{{ default_model?.description }}</div>
        </div>
      </template>
      <div class="flex-center no-select pointer">
        <div class="name olh">
          <span>{{ default_model?.display_name }}</span>
        </div>
      </div>
    </Bubble>
    <div
      v-if="!canSelected && createRenderType == 'mobile'"
      class="flex-center no-select pointer"
      @click="showAction"
    >
      <div class="name flex1 olh">
        <span>{{
          createRenderType == "pc"
            ? default_model?.display_name
            : formatDisplayName(default_model?.display_name)
        }}</span>
      </div>
    </div>
    <el-popover
      :visible="
        createRenderType == 'pc' &&
        choose_model_data.show_choose_model &&
        choose_model_data.is_show &&
        !showSongModelClickGuideState
      "
      placement="bottom"
      :width="236"
      :show-arrow="false"
      :popper-style="{
        padding: 0,
        'border-radius': '12px !important',
        border: 'none',
        marginTop: '4px', // 往下移动 4px
      }"
    >
      <template #reference>
        <el-dropdown
          v-if="canSelected && createRenderType == 'pc'"
          ref="refElDropdown"
          popper-class="model-drop"
          placement="bottom-end"
          trigger="hover"
          @command="handleCommand"
          @visible-change="dropdownChange"
        >
          <div class="el-dropdown-link flex-center pointer">
            <div class="name flex1 olh">
              <template v-if="current_model?.display_name">
                {{ current_model.display_name }}
              </template>
              <div v-else class="loading-placeholder flex-center">
                <img src="@/assets/img/loading-mini-white-3x.png" alt="" />
              </div>
            </div>
            <img
              class="select"
              :class="isOpen ? 'select-open' : ''"
              src="@/assets/img/lora/select-up.png"
              alt=""
            />
          </div>
          <template #dropdown>
            <el-dropdown-menu class="dropdown-menu-container">
              <div class="scrollable-dropdown-items" ref="scrollContainerRef">
                <el-dropdown-item
                 class="el-dropdown-item"
                  v-for="item in model_list"
                  :key="item.model"
                  :command="item"
                  :data-model-id="item.model"
                >
                  <div class="model-card">
                    <div
                      class="free-flag flex-center"
                      v-if="item.free_to_use == 1"
                    >
                      首次免费
                    </div>
                    <div
                      class="model-title flex-row-center"
                      :class="{
                        'model-title-used': item.model == current_model?.model,
                      }"
                    >
                      {{ item.display_name }}
                    </div>
                    <div class="required-credits">
                      {{
                        $t("create.credit_per_song", {
                          credit: item.required_credits,
                          amount: item.generation_amount,
                        })
                      }}
                    </div>
                    <div class="desc">{{ item.description }}</div>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item
                  class="el-dropdown-item"
                  v-for="item in lora_model_list"
                  :key="item.id"
                  :command="{
                    ...item,
                    uid: userInfo?.user?.id,
                  }"
                  :data-model-id="item.model"
                >
                  <div class="model-card">
                    <div
                      class="model-title flex-row-center"
                      :class="{
                        'model-title-used': item.model == current_model?.model,
                      }"
                    >
                      {{ item.display_name }}
                    </div>
                    <div class="required-credits">
                      {{
                        $t("create.credit_per_song", {
                          credit: item.required_credits,
                          amount: item.generation_amount,
                        })
                      }}
                    </div>
                  </div>
                </el-dropdown-item>
              </div>
              <div class="fixed-dropdown-items">
                <el-dropdown-item
                  v-if="
                    [1, 2, 4].includes(lora_state) &&
                    ModuleOpenStateControl.model.custom
                  "
                  :disabled="true"
                >
                  <div class="model-state">
                    <div class="flex">
                      <div class="name flex1 olh">
                        {{ show_modle.display_name }}
                      </div>
                      <div v-if="lora_state == 1" class="wait-tip">
                        {{ $t("create.in_the_queue", { wait_num }) }}
                      </div>
                      <div
                        v-else-if="lora_state == 2"
                        class="flex-center generating-tip"
                      >
                        <LoaderCircle
                          :loading="true"
                          :size="14"
                          :strokeWidth="1"
                          color="#fff"
                        />
                        <div class="text">{{ $t("create.in_training") }}</div>
                      </div>
                      <div class="fail-tip" v-else>
                        {{ $t("create.model_training_error") }}
                      </div>
                    </div>
                    <div class="show">
                      <div v-if="lora_state == 1" class="wait-line"></div>
                      <div v-else-if="lora_state == 2" class="generating-line">
                        <div
                          class="generating-line-progress"
                          :style="{ width: generating_progress + '%' }"
                        ></div>
                      </div>
                      <div v-else class="fail-box flex">
                        <div class="pointer flex-center" @click="handleRestore">
                          <img
                            v-if="!restoreLoading"
                            src="@/assets/img/lora/restore.png"
                            alt=""
                          />
                          <LoaderCircle
                            v-else
                            :loading="true"
                            :size="16"
                            :strokeWidth="1"
                            color="#fff"
                          />
                        </div>
                        <div class="pointer flex-center" @click="handleCancel">
                          <img
                            v-if="!cancelLoading"
                            src="@/assets/img/lora/del.png"
                            alt=""
                          />
                          <LoaderCircle
                            v-else
                            :loading="true"
                            :size="16"
                            :strokeWidth="1"
                            color="#fff"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item
                  command="add"
                  v-if="
                    ![1, 2, 4].includes(lora_state) &&
                    ModuleOpenStateControl.model.custom
                  "
                >
                  <div class="model-card model-card-add flex-row-center">
                    <div class="add-flag">
                      <img src="@/assets/img/lora/add.png" alt="" />
                    </div>
                    <div class="desc">{{ $t("create.create_model") }}</div>
                  </div>
                </el-dropdown-item>
              </div>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </template>
      <template #default>
        <GuideTip></GuideTip>
      </template>
    </el-popover>

    <div
      v-if="canSelected && createRenderType == 'mobile'"
      class="mobile-version-wrapper flex-center"
      @click="handleClickMobileModel"
    >
      <div class="name flex1 olh width-0">
        <template v-if="current_model?.display_name">
          {{ formatDisplayName(current_model?.display_name) }}
        </template>
        <div v-else class="loading-placeholder flex-center">
          <img src="@/assets/img/loading-mini-white-3x.png" alt="" />
        </div>
      </div>
      <img src="@/assets/img/lora/arrow.png" alt="" />
      <GuideTip
        v-if="
          createRenderType == 'mobile' &&
          choose_model_data.show_choose_model &&
          choose_model_data.is_show &&
          !showSongModelClickGuideState
        "
      ></GuideTip>
      <!-- <div class="mobile-tip">
        <GuideTip></GuideTip>
      </div> -->
    </div>
    <AddModelDialog
      v-if="renderData.train_visible"
      v-model:visible="renderData.train_visible"
      :productList="productList"
      @paySuccess="handlePaySuccess"
    ></AddModelDialog>
    <CreateModelDialog
      v-if="renderData.model_visible"
      v-model:visible="renderData.model_visible"
      :isLoading="isLoading"
      @createModel="handleCreateModel"
    >
    </CreateModelDialog>
    <MobileChooseDialog
      v-if="createRenderType == 'mobile' && renderData.model_choose_visible"
      v-model:visible="renderData.model_choose_visible"
      :restoreLoading="restoreLoading"
      :cancelLoading="cancelLoading"
      @handleRestore="handleRestore"
      @handleCancel="handleCancel"
      @handleAddModel="handleCommand('add')"
      @handleSelectModel="(item) => handleCommand(item)"
    ></MobileChooseDialog>
  </div>
</template>

<script setup>
import {
  reactive,
  defineProps,
  onMounted,
  ref,
  getCurrentInstance,
  onUnmounted,
} from "vue";
import { useRoute, useRouter } from "vue-router";
import { storeToRefs } from "pinia";
import { ModuleOpenStateControl } from "@/config/config.js";
import { getNewProducts, checkoutCallBack } from "@/api/api/apiCredit.js";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
import useModelDataStore from "@/store/model/modelDataStore.js";
import useUserDataStore from "@/store/userDataStore";
import useGlobalUserStateStore from "@/store/globalUserStateStore.js";
import message from "@/components/functionCallComponent/message.jsx";
import { showActionDialog } from "@/components/functionCallComponent/action/action.js";
import LoaderCircle from "@/components/animation/LoaderCircle.vue";
import { $$t } from "@/i18n/i18n.js";
import AddModelDialog from "./addModelDialog.vue";
import CreateModelDialog from "./createModelDialog.vue";
import MobileChooseDialog from "./mobileChooseDialog.vue";
import GuideTip from "./guideTip.vue";
import tools from "@/utils/tools.js";

const route = useRoute();
const Router = useRouter();
const globalProperties =
  getCurrentInstance()?.appContext.config.globalProperties;
const createLayoutStore = useCreateLayoutStore();
const userDataStore = useUserDataStore();
const modelDataStore = useModelDataStore();
const globalUserStateStore = useGlobalUserStateStore();
const { createRenderType, createEditMode } = storeToRefs(createLayoutStore);
const { showSongModelClickGuideState } = storeToRefs(globalUserStateStore);
const {
  model_list,
  lora_model_list,
  current_model,
  default_model,
  lora_id,
  lora_state,
  wait_num,
  generating_progress,
  show_modle,
  choose_model_data,
} = storeToRefs(modelDataStore);
const { userInfo, isLogin } = storeToRefs(userDataStore);
const props = defineProps({
  canSelected: {
    type: Boolean,
    default: true,
  },
  controlType: {
    type: String,
    default: "",
  },
  mode: {
    type: String,
    default: "",
  },
});

const refElDropdown = ref(null);
const renderData = reactive({
  train_visible: false,
  model_visible: false,
  model_choose_visible: false,
});
const isLoading = ref(false);
const restoreLoading = ref(false);
const cancelLoading = ref(false);
const productList = ref([]);
const isOpen = ref(false);
const visibleModelIds = ref(new Set());
const scrollContainerRef = ref(null);
const isInitializing = ref(false); // 新增状态锁
let observer = null;

const formatDisplayName = (name) => {
  return name ? name.replace(/Mureka/g, "") : "";
};

const handleClickMobileModel = () => {
  renderData.model_choose_visible = true;
  globalProperties.logCustomEvent("create_model_unfold_click", {
    tab_stare: createEditMode.value == "easy" ? "basic" : "advanced",
  });
};


// 防抖处理滚动事件
const handleScroll = tools.debounce(() => {
  logVisibleModels();
}, 200);

const initIntersectionObserver = () => {
  if (observer) observer.disconnect();
  
  const dropdownMenu = scrollContainerRef.value || document.querySelector('.dropdown-menu-container');
  if (!dropdownMenu) return;

  // 添加滚动监听
  dropdownMenu.addEventListener('scroll', handleScroll);

  observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        const modelId = entry.target.getAttribute('data-model-id');
        if (entry.isIntersecting) {
          visibleModelIds.value.add(modelId);
        } else {
          visibleModelIds.value.delete(modelId);
        }
      });
    },
    {
      threshold: 0.1,
      root: dropdownMenu
    }
  );

  document.querySelectorAll('.el-dropdown-item[data-model-id]').forEach(el => {
    observer.observe(el);
  });
};

const logVisibleModels = () => {
  const visibleIds = Array.from(visibleModelIds.value).join(",");
  globalProperties.logCustomEvent("create_model_list_show", {
    source: visibleIds,
    tab_stare: createEditMode.value == "easy" ? "basic" : "advanced",
  });
};


const dropdownChange = async (flag) => {
  if (isInitializing.value) return; // 防止重复执行
  isInitializing.value = true;
  isOpen.value = flag;
  if (flag) {
    modelDataStore.updataChooseModelPop();
    globalProperties.logCustomEvent("create_model_unfold_click", {
      tab_stare: createEditMode.value == "easy" ? "basic" : "advanced",
    });
    
    await nextTick();
    // scrollContainerRef.value = document.querySelector('.scrollable-dropdown-items');
    initIntersectionObserver();
    setTimeout(() => {
      logVisibleModels();
      isInitializing.value = false; // 执行完成后释放锁
    }, 1000);
  } else {
    visibleModelIds.value.clear();
    if (observer) observer.disconnect();
    if (scrollContainerRef.value) {
      scrollContainerRef.value.removeEventListener('scroll', handleScroll);
    }
    isInitializing.value = false;
  }
};



// const dropdownChange = (flag) => {
//   isOpen.value = flag;
//   if (flag) {
//     modelDataStore.updataChooseModelPop();
//     globalProperties.logCustomEvent("create_model_unfold_click", {
//       tab_stare: createEditMode.value == "easy" ? "basic" : "advanced",
//     });
//     globalProperties.logCustomEvent("create_model_list_show", {
//       source: [...model_list.value, ...lora_model_list.value]
//         .map((item) => item.model)
//         .join(","),
//       tab_stare: createEditMode.value == "easy" ? "basic" : "advanced",
//     });
//   }
// };

const handleCommand = async (command) => {
  if (command == "add") {
    globalProperties.logCustomEvent("create_model_list_create_click", {
      tab_stare: createEditMode.value == "easy" ? "basic" : "advanced",
    });
    if (!(await userDataStore.checkLoginStatus())) {
      return;
    }
    if (lora_id.value && lora_state.value == 7) {
      renderData.model_visible = true;
      globalProperties.logCustomEvent("train_your_personal_model_show", {
        tab_stare: createEditMode.value == "easy" ? "basic" : "advanced",
      });
    } else {
      renderData.train_visible = true;
    }
  } else {
    modelDataStore.updateCurrentModel(command).then(() => {
      if (createRenderType.value == "mobile") {
        renderData.model_choose_visible = false;
      }
    });
  }
};

const showAction = () => {
  showActionDialog({
    title: default_model.value?.display_name,
    content: default_model.value?.description,
    hideCancel: true,
    confirm(closeDialog) {
      closeDialog();
      userDataStore.upDataAuthData({});
      userDataStore.updateLoginStatus(false);
    },
    cancel() {},
  });
};

const handleCreateModel = () => {
  globalProperties.logCustomEvent("create_my_model_click", {
    tab_stare: createEditMode.value == "easy" ? "basic" : "advanced",
  });
  isLoading.value = true;
  modelDataStore
    .createModel()
    .then(() => {
      isLoading.value = false;
      renderData.model_visible = false;
      if (createRenderType.value == "pc") {
        refElDropdown.value.handleOpen();
      } else {
        renderData.model_choose_visible = true;
      }
    })
    .catch((res) => {
      isLoading.value = false;
      if (res.code == 6349) {
        message.error({
          position: "top",
          content: $$t("create.personal_model_in_progress"),
        });
      }
    });
};

// 重新生成
const handleRestore = () => {
  restoreLoading.value = true;
  modelDataStore.createModel().then(() => {
    restoreLoading.value = false;
  });
};

// 取消生成
const handleCancel = () => {
  cancelLoading.value = true;
  modelDataStore.cancelFailLora().then(() => {
    cancelLoading.value = true;
    // renderData.model_visible = false;
    // refElDropdown.value.handleOpen();
  });
};

async function pollGetResult(maxAttempts = 10, interval = 2000) {
  const { token } = route.query;
  for (let attempt = 1; attempt <= maxAttempts; attempt++) {
    try {
      const res = await checkoutCallBack({
        paypal_order_id: token,
      });

      if (res.code == 200 || res.code == 8003) {
        removeQueryParam("thp_channel");
        // getCurrentCredits();
        modelDataStore.getLoraId().then(() => {
          if (lora_id.value && lora_state.value == 7) {
            modelDataStore.init();
            if (route?.query?.is_create_model == 1) {
              removeQueryParam("is_create_model");
              renderData.model_visible = true;
              globalProperties.logCustomEvent(
                "train_your_personal_model_show",
                {
                  tab_stare:
                    createEditMode.value == "easy" ? "basic" : "advanced",
                }
              );
            }
          }
        });
        return res;
      }
    } catch (error) {
      console.error(`Attempt ${attempt} failed:`, error);
    }

    if (attempt < maxAttempts) {
      await new Promise((resolve) => setTimeout(resolve, interval)); // 等待一段时间再重试
    }
  }
  return null;
}

const removeQueryParam = (paramKey) => {
  const newQuery = { ...route.query };
  delete newQuery[paramKey];

  Router.replace({ query: newQuery });
};

const getProduct = () => {
  getNewProducts({
    platform: "html",
    category: "normal",
    lora: true,
  }).then((res) => {
    if (res.code == 200) {
      productList.value = res?.data?.list;
    }
  });
};

watch(
  () => userDataStore.isLogin,
  (val) => {
    if (!val) {
      refElDropdown.value?.handleClose();
      modelDataStore.resetModel();
    } else {
      modelDataStore.getAllModelList().then((res) => {});
      getProduct();
      if (props.canSelected) {
        const { thp_channel } = route.query;
        if (thp_channel && thp_channel == "paypal") {
          pollGetResult();
        } else {
          modelDataStore.getLoraId().then(() => {
            if (lora_id.value && lora_state.value == 7) {
              modelDataStore.init();
              if (route?.query?.is_create_model == 1) {
                removeQueryParam("is_create_model");
                renderData.model_visible = true;
              }
            }
          });
        }
      }
    }
  }
);

watch(
  () => userDataStore.appLanguage,
  () => {
    nextTick().then(() => {
      getProduct();
      modelDataStore.getAllModelList();
    });
  }
);

const handlePaySuccess = () => {
  modelDataStore.getLoraId().then(() => {
    if (lora_id.value && lora_state.value == 7) {
      modelDataStore.init();
      renderData.model_visible = true;
      globalProperties.logCustomEvent("train_your_personal_model_show", {
        tab_stare: createEditMode.value == "easy" ? "basic" : "advanced",
      });
    }
  });
};

onMounted(async() => {
  modelDataStore.getAllModelList().then((res) => {
    globalProperties.logCustomEvent("create_model_show", {
      source: res.display_name,
      tab_stare: createEditMode.value == "easy" ? "basic" : "advanced",
    });
  });

  if (props.canSelected && isLogin.value) {
    getProduct();
    const { thp_channel } = route.query;
    if (thp_channel && thp_channel == "paypal") {
      pollGetResult();
    } else {
      modelDataStore.getLoraId().then(() => {
        if (lora_id.value && lora_state.value == 7) {
          modelDataStore.init();
          if (route?.query?.is_create_model == 1) {
            removeQueryParam("is_create_model");
            message.success({
              position: "top",
              content: $$t("create.payment_successful_and_create_model"),
            });
            renderData.model_visible = true;
          }
        }
      });
    }
  }
  if (!isLogin.value) {
    modelDataStore.resetModel();
  }
  await nextTick(); // 等待DOM更新
  if (scrollContainerRef.value) {
    scrollContainerRef.value.addEventListener("scroll", handleScroll);
    initIntersectionObserver();
  }
});

onUnmounted(() => {
  modelDataStore.updataChooseModelPop(); // 隐藏元素
  // 确保组件卸载时清理
  if (observer) observer.disconnect();
  if (scrollContainerRef.value) {
    scrollContainerRef.value.removeEventListener('scroll', handleScroll);
  }
  modelDataStore.updataChooseModelPop();
});
</script>

<style lang="scss">
@keyframes opacityAnimation {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
  100% {
    opacity: 1;
  }
}
.default-model-popover {
  padding: 18px 20px;
  .default-model-tip {
    width: 300px;
    .name {
      font-size: 14px;
      font-weight: bold;
    }
    .desc {
      font-size: 12px;
      margin-top: 8px;
      line-height: 150%;
    }
  }
}

.model-drop {
  border: none !important;
  border-radius: 8px !important;
  width: 300px;
  background: unset !important;
  box-shadow: none !important;
  opacity: 1;
  .dropdown-menu-container {
    display: flex;
    flex-direction: column;
    max-height: calc(100vh - 200px); /* 设置最大高度 */
  }

  /* 可滚动部分 */
  .scrollable-dropdown-items {
    flex: 1; /* 占据剩余空间 */
    overflow-y: auto; /* 启用垂直滚动 */
  }

  .el-popper__arrow {
    display: none;
  }
  .el-dropdown-menu {
    padding: 0;
    background-color: rgba(255, 255, 255, 0.1) !important;
    backdrop-filter: blur(100px);
    border: none;
    border-radius: 8px !important;
    overflow: hidden;
  }
  .el-dropdown-menu__item {
    position: relative;
    // background-color: rgba(255, 255, 255, 0.1) !important;
    padding: 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    white-space: pre-wrap;
    &:hover {
      background-color: rgba(255, 255, 255, 0.1) !important;
      backdrop-filter: blur(0);
    }
    // &:last-of-type {
    //   border-bottom: none;
    // }
    &:not(.is-disabled):focus {
      background-color: rgba(255, 255, 255, 0.1) !important;
      backdrop-filter: blur(100px);
    }
    &:not(.is-disabled):hover {
      background-color: rgba(255, 255, 255, 0.1) !important;
      backdrop-filter: blur(100px);
    }
    .model-card {
      position: relative;
      width: 100%;
      padding: 18px 20px;
      // background: rgba(255, 255, 255, 0.1);
      // backdrop-filter: blur(100px);
      .free-flag {
        position: absolute;
        top: 10px;
        right: 10px;
        background: linear-gradient(
          113deg,
          #ffe08b -1%,
          #fff7d0 47%,
          #ffe08b 100%
        );
        padding: 6px 8px;
        font-size: 10px;
        font-weight: 500;
        line-height: 12px;
        border-radius: 20px;
        color: #000;
      }
      .model-title {
        font-size: 16px;
        font-weight: bold;
        color: #fff;
        &-used {
          color: #94adff;
          &::after {
            flex-shrink: 0;
            content: "";
            width: 20px;
            height: 20px;
            margin-left: 8px;
            background: url("@/assets/img/lora/selected.png");
            background-size: 100% 100%;
          }
        }
      }
      .required-credits {
        margin-top: 4px;
        font-size: 12px;
        color: rgba(255, 255, 255, 0.5);
      }
      .desc {
        word-wrap: break-word;
        margin-top: 4px;
        font-size: 12px;
        line-height: 150%;
        color: rgba(255, 255, 255, 0.8);
      }
    }
    .model-card-add {
      .add-flag {
        height: max-content;
        padding: 16px;
        background: rgba(255, 255, 255, 0.2);
        border-radius: 12px;
        img {
          display: block;
          width: 24px;
          height: 24px;
        }
      }
      .desc {
        margin: 0 0 0 12px;
      }
    }
    .model-state {
      width: 100%;
      padding: 16px 20px;
      .name {
        font-size: 16px;
        font-weight: bold;
        color: rgba(255, 255, 255, 0.5);
      }
      .fail-tip {
        font-size: 14px;
        color: #ff5f74;
        margin-left: 8px;
      }
      .wait-tip {
        font-size: 14px;
        color: #fff;
        margin-left: 8px;
      }
      .generating-tip {
        margin-left: 8px;
        font-size: 14px;
        color: #fff;
        .text {
          margin-left: 4px;
        }
      }
      .show {
        margin-top: 6px;
        .wait-line {
          animation: opacityAnimation 1.8s infinite;
          border-radius: 4px;
          widows: 100%;
          height: 18px;
          background: rgba(255, 255, 255, 0.2);
        }
        .generating-line {
          position: relative;
          border-radius: 4px;
          widows: 100%;
          height: 18px;
          background: rgba(255, 255, 255, 0.2);
          overflow: hidden;
          .generating-line-progress {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            background: linear-gradient(101deg, #4fdeff 0%, #e675ff 100%);
          }
        }
        .fail-box {
          justify-content: space-between;
          > div {
            border-radius: 60px;
            width: 122px;
            height: 32px;
            background: rgba(255, 255, 255, 0.1);
            img {
              width: 16px;
              height: 16px;
            }
          }
        }
      }
    }
  }

  /* 固定部分 */
  .fixed-dropdown-items {
    .el-dropdown-menu__item {
      &:last-of-type {
        border-bottom: none;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.version-wrapper {
  width: 100%;
  height: max-content;
  position: relative;
  overflow: visible;
  .el-dropdown-link {
    width: 131px;
    box-sizing: border-box;
    padding: 5px 10px 5px 14px;
    border-radius: 64px;
    border: 1px solid;
    background: linear-gradient(92deg, #4fdeff -40%, #d9f8ff 52%, #e675ff 132%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
    &::before {
      content: "";
      position: absolute;
      inset: 0;
      border-radius: inherit;
      padding: 1px;
      background: linear-gradient(108deg, #4fdeff 0%, #e675ff 100%);
      -webkit-mask: linear-gradient(white, white) content-box,
        linear-gradient(white, white);
      -webkit-mask-composite: destination-out;
      mask-composite: exclude;
    }
    .name {
      font-size: 14px;
      font-weight: 500;
      line-height: 24px;
      color: #fff;
      .loading-placeholder {
        @keyframes spin {
          to {
            transform: rotate(360deg);
          }
        }
        img {
          animation: spin 1.5s linear infinite;
          width: 16px;
          height: 16px;
        }
      }
    }
    .select {
      width: 20px;
      height: 20px;
      margin-left: 4px;
    }
    .select-open {
      transform: rotate(180deg);
    }
  }
  .no-select {
    width: 100%;
    .name {
      font-size: 14px;
      font-weight: 500;
      line-height: 24px;
      background: linear-gradient(
        92deg,
        #4fdeff -40%,
        #d9f8ff 52%,
        #e675ff 132%
      );
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      text-fill-color: transparent;
      z-index: 0;
    }
    .question {
      width: 16px;
      height: 16px;
      margin-left: 4px;
    }
  }
  .model-box {
    background: #3e3450;
  }
}
.mobile-version-wrapper {
  box-sizing: border-box;
  position: relative;
  padding: 4px 8px 4px 10px;
  border-radius: 64px;
  border: 1px solid transparent;
  width: 100%;
  height: 34px;
  &::before {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: inherit;
    padding: 1px;
    background: linear-gradient(108deg, #4fdeff 0%, #e675ff 100%);
    -webkit-mask: linear-gradient(white, white) content-box,
      linear-gradient(white, white);
    -webkit-mask-composite: destination-out;
    mask-composite: exclude;
  }
  color: #fff;
  font-size: 14px;
  img {
    width: 16px;
    height: 16px;
  }
  .mobile-tip {
    // position: absolute;
    // top: 0;
    // left: 50%;
    // transform: translateY(38px) translateX(-50%);
    width: 200px;
  }
  .name {
    .loading-placeholder {
      @keyframes spin {
        to {
          transform: rotate(360deg);
        }
      }
      img {
        animation: spin 1.5s linear infinite;
        width: 15px;
        height: 15px;
      }
    }
  }
}
</style>